import * as yup from 'yup';
import { BarStatusType, BarType, WeekDays } from '../types';

export const createBarDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  venueId: yup.string().required().label('Venue'),
  contacts: yup.array().of(yup.string().required()).required().label('Contacts'),
  barType: yup.mixed<BarType>().oneOf(Object.values(BarType)).nullable().label('Specific type'),
  statusType: yup
    .mixed<BarStatusType>()
    .oneOf(Object.values(BarStatusType))
    .label('Status type')
    .default(BarStatusType.ACTIVE),
  openingHour: yup.string().nullable().default(null).label('Opening Hour'),
  closingHour: yup.string().nullable().default(null).label('Closing Hour'),
  closedDay: yup
    .string()
    .nullable()
    .optional()
    .oneOf([...Object.values(WeekDays), null])
    .label('Closed Day'),
  accessDuringLicense: yup.boolean().nullable().default(false).label('Access During License'),
  description: yup.string().nullable().default(null).label('Description'),
  accessDays: yup.array().nullable().label('Access days'),
  accessWindowOpen: yup.string().nullable().default(null).label('Product Window Open'),
  accessWindowClose: yup.string().nullable().default(null).label('Access Window Close'),
  productDeliveryDays: yup.array().nullable().label('Product Delivery Days')
});
export const updateBarDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  venueId: yup.string().required().label('Venue'),
  contacts: yup.array().of(yup.string().required()).required().label('Contacts'),
  barType: yup.mixed<BarType>().oneOf(Object.values(BarType)).nullable().label('Specific type'),
  statusType: yup
    .mixed<BarStatusType>()
    .oneOf(Object.values(BarStatusType))
    .label('Status type')
    .default(BarStatusType.ACTIVE),
  openingHour: yup.string().nullable().default(null).label('Opening Hour'),
  closingHour: yup.string().nullable().default(null).label('Closing Hour'),
  closedDay: yup
    .string()
    .nullable()
    .optional()
    .oneOf([...Object.values(WeekDays), null])
    .label('Closed Day'),
  accessDuringLicense: yup.boolean().nullable().default(false).label('Access During License'),
  description: yup.string().nullable().default(null).label('Description'),
  accessDays: yup.array().nullable().label('Access days'),
  accessWindowOpen: yup.string().nullable().default(null).label('Product Window Open'),
  accessWindowClose: yup.string().nullable().default(null).label('Access Window Close'),
  productDeliveryDays: yup.array().nullable().label('Product Delivery Days'),
  defaultPythonId: yup.string().optional().nullable().default(null).label('Default python')
});
